import React from 'react';

const OkStatus: React.FC = () => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <title>ok</title>
      <path
        d="M27.604 3.372a1.155 1.155 0 0 0-1.628.112L11.614 19.958 6.477 17.15a1.19 1.19 0 0 0-1.503 1.784l5.457 6.865a2.473 2.473 0 0 0 4.014-.198l.179-.278L27.816 4.867a1.153 1.153 0 0 0-.212-1.495z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
};

const FailedStatus: React.FC = () => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
      <title>failed</title>
      <path
        d="M29.546 25.249L17.898 5.083c-.644-1.112-2.254-1.112-2.898 0L3.351 25.249c-.644 1.112.147 2.517 1.434 2.517h23.298a1.676 1.676 0 0 0 1.463-2.517zm-13.463-13.99c.702-.176 1.405.175 1.727.819.117.234.146.498.117.732a53.757 53.757 0 0 0-.117 2.224c-.059 1.142-.147 2.312-.205 3.454-.03.351-.03.702-.059 1.083-.029.614-.497 1.083-1.112 1.083a1.12 1.12 0 0 1-1.112-1.054c-.088-1.785-.205-3.57-.293-5.356-.029-.468-.058-.966-.088-1.434 0-.703.469-1.376 1.142-1.551zm.38 13.404c-.82 0-1.463-.673-1.463-1.492 0-.82.673-1.493 1.493-1.493.82 0 1.463.673 1.463 1.522-.03.79-.702 1.463-1.493 1.463z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
};

export { OkStatus, FailedStatus };
